export default function preloaderGame2 (scene) {

    scene.load.image(`tilesgame2`, `/tiles/game2.png`);
    scene.load.image(`noLightstickgame2`, `/tiles/noLightstick-game2.png`);

	scene.load.audio("goodnightSong", ["/audio/songs/2-goodnight.mp3"]);

	scene.load.spritesheet(`jiu-game2`, 
		`/img/game2/jiu.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`sua-game2`, 
		`/img/game2/sua.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`siyeon-game2`, 
		`/img/game2/siyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`handong-game2`, 
		`/img/game2/handong.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`yoohyeon-game2`, 
		`/img/game2/yoohyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`dami-game2`, 
		`/img/game2/dami.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`gahyeon-game2`, 
		`/img/game2/gahyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`enemy-game2`, 
		`/img/game2/enemy.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`humo-game2`, 
		`/img/generalSprites/humo-infinite.png`,
			{ frameWidth: 41, frameHeight: 42}
		);

	scene.load.tilemapTiledJSON(`game2`, `/tiles/game2.tmj`);

}